import React, { useContext, useEffect, useState } from 'react'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { Image, KeyboardAvoidingView, Platform, ScrollView, Text, View } from 'react-native'
import { globalStyle } from '../../../../../theme/global'
import { StackNavigationProp } from '@react-navigation/stack'
import { LogisticsRoutes } from '../../../../../navigator/types'
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native'
import { GrayHeader } from '../../components/GrayHeader'
import { TextInputComponent } from '../../../../../components/TextInputComponent'
import { Button } from '../../../../../components/Button'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { useForm } from '../../../../../hooks/useForm'
import { useTranslation } from 'react-i18next'
import { useKeyboardVisibility } from '../../../../../hooks/useKeyboardVisibility'
import { useMoveScroll } from '../../../../../hooks/useMoveScroll'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { textColor } from '../../../../../theme/colors'

export const MeterLog = () => {
  const { handleValueNumber, form, getMaxCapacityByArtifact } = useContext(FuelContext)
  const { t } = useTranslation()
  const navigation = useNavigation<StackNavigationProp<LogisticsRoutes, 'MeterLog'>>()
  const route = useRoute<RouteProp<LogisticsRoutes, 'MeterLog'>>()
  const { values, onChangeValues } = useForm({
    meterLog: '',
    maxCapacity: 0,
  })
  const [alert, setAlert] = useState({ show: false })
  const [minLiters, setMinLiters] = useState(false)
  const { handleKeyboardPadding } = useKeyboardVisibility()
  const { scrollViewRef } = useMoveScroll({
    handleKeyboardPadding,
  })

  const handleNext = () => {
    if (+values.meterLog > values.maxCapacity) {
      setAlert({
        show: true,
      })
      return
    }
    handleValueNumber({ type: 'meterNumber', value: +values.meterLog })
    navigation.navigate(route.params?.returnToSummary ? 'Summary' : 'VoucherPhoto')
  }

  useEffect(() => {
    const maxCapacity = getMaxCapacityByArtifact({
      artifactId: form.pontoonId!,
      centerId: form.centerId!,
    })
    onChangeValues({ name: 'maxCapacity', value: maxCapacity })
  }, [form.centerId, form.pontoonId])

  const formatValue = (value: number): string => value.toLocaleString().replace(',', '.')

  return (
    <TemplatePage
      header
      styleContent={{ padding: 0, marginBottom: 0 }}
      title={t('Recepción combustible')}
    >
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={[globalStyle.viewContainer, { padding: 0 }]}
        keyboardVerticalOffset={50}
      >
        <ScrollView ref={scrollViewRef}>
          <GrayHeader title={t('Registro medidor final')} />

          <View style={{ padding: 24 }}>
            <Image
              source={{ uri: form.photos?.finalPhotoMeter?.uri }}
              resizeMode='cover'
              style={{ width: '100%', height: 350, borderRadius: 8 }}
            />
          </View>

          <View style={{ gap: 28, padding: 24, paddingTop: 0 }}>
            <TextInputComponent
              label={`${t('Ingrese litros')} (max. ${formatValue(values.maxCapacity)} lts.)`}
              onChange={(value) => {
                if (Number(value) <= 0 && value !== '') {
                  setMinLiters(true)
                } else {
                  onChangeValues({ name: 'meterLog', value })
                }
              }}
              value={values.meterLog}
              keyboardType='numeric'
            />
            <View style={{ flexDirection: 'row', gap: 24, justifyContent: 'center' }}>
              <Button
                label={t('Repetir foto')}
                variant='white'
                onPress={() => navigation.replace('FinalPhotoMeter')}
              />
              <Button
                label={t('Continuar')}
                onPress={handleNext}
                disabled={Number(values.meterLog) <= 0}
              />
            </View>
          </View>

          {alert.show && (
            <AlertMessage action={() => setAlert({ show: false })} title='Error'>
              <Text style={{ color: textColor }}>
                El valor del medidor no puede superar el 120% de la capacidad nominal de los
                estanques.
                {formatValue(+values.meterLog)} {'>'} {formatValue(values.maxCapacity)}
              </Text>
            </AlertMessage>
          )}

          {minLiters && (
            <AlertMessage action={() => setMinLiters(false)} title='Error'>
              <Text style={{ color: textColor }}>Ingrese un valor mayor que 0</Text>
            </AlertMessage>
          )}
        </ScrollView>
      </KeyboardAvoidingView>
    </TemplatePage>
  )
}
